// test1622
(1622 && 0);
